import BackButtonToolbar from "features/BackButtonToolbar";
import { Show, useShowController } from "react-admin";
import { SectionTitle } from "features/SectionTitle";
import PersonalData from "./PersonalData";
import UndergraduateData from "./UndergraduateData";
import Requirements from "./Requirements";
import MonthlyInternshipData from "./MonthlyInternshipData";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import StudentTrainingBasesAdmin from "./StudentTrainingBasesAdmin";

const ShowInternshipStudents = () => {
  const { record } = useShowController();
  const hasDisciplineRequirements = record?.hasDisciplineRequirements;

  return (
    <Show
      title="Детайли за студент"
      actions={<BackButtonToolbar />}
    >
      <SectionTitle
        paddingY={2}
        title="Лични данни на студента"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <PersonalData record={record} />
      <SectionTitle
        paddingY={2}
        title="Данни за преддипломен стаж"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <UndergraduateData />
      {hasDisciplineRequirements && (
        <SecuredComponent permission={permissions.canPreviewInternshipStudentsDisciplineRequirements}>
          <SectionTitle
            paddingY={2}
            title="Нормативи"
            textAlign="center"
            sx={{ marginTop: "2rem" }}
          />
          <Requirements record={record} />
        </SecuredComponent>
      )}
      {record?.isPlanMonthlyInternship && (
        <>
          <SectionTitle
            paddingY={2}
            title="Месечен стаж"
            textAlign="center"
            sx={{ marginTop: "2rem" }}
          />
          <MonthlyInternshipData studentEducationId={record?.studentEducationId} />
        </>
      )}
      {record?.hasPlanWards && (
        <SecuredComponent permission={permissions.canPreviewStudentsTrainingBases}>
          <SectionTitle
            paddingY={2}
            title="Учебни бази"
            textAlign="center"
            sx={{ marginTop: "2rem" }}
          />
          <StudentTrainingBasesAdmin studentEducationId={record?.studentEducationId} />
        </SecuredComponent>
      )}
    </Show>
  );
};

export default ShowInternshipStudents;
